
import { Box, Link, Stack, Typography } from "@mui/material";

import type { WidgetProps } from "./types";

export function PDFEmbed({ widget }: WidgetProps<"pdf_embed">) {
    const { url, title, height } = widget.props;
    const h = height ?? 720;

    return (
        <Stack spacing={1}>
            {title && <Typography variant="h5">{title}</Typography>}
            <Box
                component="iframe"
                src={url}
                title={title ?? "PDF document"}
                sx={{
                    width: "100%",
                    height: h,
                    border: 1,
                    borderColor: "divider",
                    borderRadius: "10px",
                    bgcolor: "background.paper",
                }}
            />
            <Typography variant="caption" color="text.secondary">
                If the document does not load above,{" "}
                <Link href={url} target="_blank" rel="noopener noreferrer">
                    open it in a new tab
                </Link>
                .
            </Typography>
        </Stack>
    );
}
